<template>
  <div id="table-helper" class="pa-5">
    <TableHelper
      ref="table"
      :enable-select="true"
      :fields="fields"
      :items="items"
      :actions="actions"
      :meta="meta"
      :enable-filter="true"
      :filterable="filterable"
      loading-key="table-helper-demo"
      param-prefix="demo"
      @reload-data="loadData"
      @edit="showDetails"
      @editor="showDetails"
      @delete="deleteProject"
    />
  </div>
</template>

<script setup>
import TableHelper from "@/components/Tools/TableHelper/TableHelper.vue";
import { getCurrentInstance, ref } from "vue";
import { useRouter } from "vue-router/composables";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";

const router = useRouter();
const i18n = getCurrentInstance().proxy.$i18n;
const toast = getCurrentInstance().proxy.$toast;
const table = ref(null);
const fields = ref([
  {
    key: "id",
    label: "ID",
    sortable: true,
    thStyle: { width: "350px" }
  },
  {
    key: "username",
    label: "Name",
    sortable: true
  },
  {
    key: "email",
    label: "E-Mail",
    sortable: true
  },
  {
    key: "description",
    label: "Description",
    sortable: true
  },
  {
    key: "active",
    label: "Active",
    type: "activeBadge",
    sortable: true
  },
  {
    key: "state",
    label: i18n.t("salesChannelManagementApp.reporting.state"),
    type: "importState",
    sortable: true,
    entity: "salesOrder"
  },
  {
    key: "state2",
    label: "State 2",
    type: "statusDatetime",
    dateTimeStart: "date1",
    errorKey: "date2",
    sortable: true
  }
]);
const items = ref([
  {
    id: 1,
    username: "admin",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.",
    email: "admin@test.de",
    role: "admin",
    active: true,
    state: "imported",
    state2: "true",
    date1: {
      $date: {
        $numberLong: "1751271229000"
      }
    },
    date2: ""
  },
  {
    id: 2,
    username: "",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    email: "user@test.de",
    role: "user",
    active: false,
    state: "importStarted",
    state2: "true",
    date1: {
      $date: {
        $numberLong: "1750150618000"
      }
    },
    date2: "Error"
  },
  {
    id: 2,
    username: "user",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    email: "user@test.de",
    role: "user",
    active: false,
    state: "error"
  },
  {
    id: 2,
    username: "user",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    email: "user@test.de",
    role: "user",
    active: false,
    state: "imported"
  },
  {
    id: 3,
    username: "moderator",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    email: "moderator@test.de",
    role: "admin",
    active: true,
    state: "imported",
    state2: "true",
    date1: {
      $date: {
        $numberLong: "1753986542000"
      }
    },
    date2: ""
  },
  {
    id: 4,
    username: "",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.",
    email: "guest@test.de",
    role: "user",
    active: false,
    state: "importStarted",
    state2: "false",
    date1: {
      $date: {
        $numberLong: "1762586741000"
      }
    },
    date2: "Error"
  },
  {
    id: 5,
    username: "testuser",
    description: "Lorem ipsum dolor sit amet.",
    email: "testuser@test.de",
    role: "user",
    active: true,
    state: "error",
    date1: {
      $date: {
        $numberLong: "1764914892000"
      }
    }
  },
  {
    id: 6,
    username: "supervisor",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    email: "supervisor@test.de",
    role: "admin",
    active: true,
    state: "imported",
    state2: "true",
    date1: {
      $date: {
        $numberLong: "1756422135000"
      }
    },
    date2: ""
  },
  {
    id: 7,
    username: "",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.",
    email: "anonymous@test.de",
    role: "user",
    active: false,
    state: "importStarted",
    date1: {
      $date: {
        $numberLong: "1758255647000"
      }
    },
    date2: "Error"
  },
  {
    id: 7,
    username: "anonymous",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do.",
    email: "anonymous@test.de",
    role: "user",
    active: false,
    state: "error"
  },
  {
    id: 8,
    username: "developer",
    description: "Lorem ipsum dolor sit amet.",
    email: "dev@test.de",
    role: "admin",
    active: true,
    state: "imported",
    state2: "true",
    date1: {
      $date: {
        $numberLong: "1759863421000"
      }
    },
    date2: ""
  }
]);
// const items = ref([]);
const meta = ref({});
const filterable = ref({});

const actions = ref([
  {
    key: "editor",
    icon: "fal fa-paint-brush",
    emit: "editor",
    tooltip: "Test"
  },
  {
    key: "edit",
    icon: "fal fa-pen",
    emit: "edit"
  },
  {
    key: "delete",
    icon: "fal fa-trash",
    emit: "delete"
  },
  {
    key: "options",
    icon: "fal fa-ellipsis-v",
    tooltip: "Mehr",
    children: [
      {
        key: "example1",
        label: "Example 1",
        emit: "example1"
      },
      {
        key: "example2",
        label: "Example 2",
        emit: "example2"
      }
    ]
  }
]);

function loadData() {
  addEventToLoadingQueue({ key: "table-helper-demo" });
  removeEventFromLoadingQueue({ key: "table-helper-demo" });
}

function showDetails(data) {
  router.push({
    name: "projectSettingsProjectsDetails",
    params: { projectId: data.item.id }
  });
}

function deleteProject() {
  toast.fire({
    icon: "success",
    title: i18n.t("projects.deleted", { name: "Demo" })
  });
}
</script>
